import { render, staticRenderFns } from "./give.vue?vue&type=template&id=5c205583&scoped=true&"
import script from "./give.vue?vue&type=script&lang=js&"
export * from "./give.vue?vue&type=script&lang=js&"
import style0 from "./give.vue?vue&type=style&index=0&id=5c205583&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c205583",
  null
  
)

export default component.exports